import React, { useState } from 'react';
import { useT } from '../../context/TenantContext';
import MIcon from '../../components/common/MIcon';
import { api } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui';
import WatcherEmailsField from '../../components/common/WatcherEmailsField';

const PRIO = [
  { k:'low',      label:'Baja',    color:'#15803D', bg:'#F0FDF4' },
  { k:'medium',   label:'Media',   color:'#B45309', bg:'#FFFBEB' },
  { k:'high',     label:'Alta',    color:'var(--una-blue)', bg:'var(--una-blue-lt)' },
  { k:'critical', label:'Crítica', color:'#B91C1C', bg:'#FEF2F2' },
];

export default function NewTicketModal({ onClose, onCreated }) {
  const { t } = useT();
  const [form, setForm] = useState({ title:'', description:'', priority:'medium', requester:'', requester_email:'', watcher_emails:'' });
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = {
    width:'100%', height:40, padding:'0 12px',
    border:'1.5px solid #C5D8E8', borderRadius:8,
    fontSize:13, color:'#111827', outline:'none',
    boxSizing:'border-box', background:'#F8FBFD',
    transition:'border-color .15s',
  };

  async function submit() {
    if (!form.title.trim() || !form.requester.trim()) return;
    setSaving(true); setError('');
    const watcherEmails = form.watcher_emails
      .split(',').map(e => e.trim()).filter(Boolean);
    try {
      await api.createTicket({
        title:           form.title.trim(),
        description:     form.description.trim(),
        priority:        form.priority,
        requester:       form.requester.trim(),
        requester_email: form.requester_email.trim(),
        watcher_emails:  watcherEmails,
      });
      onCreated();
    } catch(e) {
      setError(e.message || 'Error al crear el ticket');
      setSaving(false);
    }
  }

  const valid = form.title.trim() && form.requester.trim();

  return (
    <div
      style={{position:'fixed',inset:0,zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(15,30,60,.5)'}}
      onClick={e => { if(e.target===e.currentTarget) onClose(); }}>
      <div style={{background:'#fff',borderRadius:12,width:640,maxWidth:'94vw',maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 8px 40px rgba(0,133,202,.18)',overflow:'hidden',border:'1px solid #E0EEF7'}}>

        {/* Header */}
        <div style={{padding:'18px 24px 16px',borderBottom:'2px solid var(--una-blue)',display:'flex',alignItems:'center',justifyContent:'space-between',background:'#F0F7FC'}}>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:'#003D6B',display:'flex',alignItems:'center',gap:8}}>
              <MIcon name="confirmation_number" size={18} style={{color:'var(--una-blue)'}}/>
              Nuevo ticket
            </div>
            <div style={{fontSize:12,color:'#5B8DB8',marginTop:2}}>Crear ticket desde el panel de agente</div>
          </div>
          <button onClick={onClose}
            style={{width:30,height:30,borderRadius:6,border:'1px solid #C5D8E8',background:'#fff',cursor:'pointer',fontSize:14,color:'#5B8DB8',display:'flex',alignItems:'center',justifyContent:'center'}}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{padding:'20px 24px 16px',display:'flex',flexDirection:'column',gap:14,overflowY:'auto',flex:1,minHeight:0}}>

          {/* Título */}
          <div>
            <label style={{fontSize:10,fontWeight:700,letterSpacing:.8,textTransform:'uppercase',color:'#5B8DB8',display:'block',marginBottom:6}}>
              Título <span style={{color:'#E53935'}}>*</span>
            </label>
            <input style={inputStyle}
              placeholder="Resumen breve del problema…"
              value={form.title} onChange={e => set('title', e.target.value)}
              onFocus={e=>e.target.style.borderColor='var(--una-blue)'} onBlur={e=>e.target.style.borderColor='#C5D8E8'}
              autoFocus
            />
          </div>

          {/* Solicitante + Email */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>
              <label style={{fontSize:10,fontWeight:700,letterSpacing:.8,textTransform:'uppercase',color:'#5B8DB8',display:'block',marginBottom:6}}>
                Solicitante <span style={{color:'#E53935'}}>*</span>
              </label>
              <input style={inputStyle}
                placeholder="Nombre completo"
                value={form.requester} onChange={e => set('requester', e.target.value)}
                onFocus={e=>e.target.style.borderColor='var(--una-blue)'} onBlur={e=>e.target.style.borderColor='#C5D8E8'}
              />
            </div>
            <div>
              <label style={{fontSize:10,fontWeight:700,letterSpacing:.8,textTransform:'uppercase',color:'#5B8DB8',display:'block',marginBottom:6}}>Email</label>
              <input style={inputStyle}
                placeholder="correo@uneatlantico.es"
                value={form.requester_email} onChange={e => set('requester_email', e.target.value)}
                onFocus={e=>e.target.style.borderColor='var(--una-blue)'} onBlur={e=>e.target.style.borderColor='#C5D8E8'}
              />
            </div>
          </div>

          {/* Emails en copia */}
          <div>
            <WatcherEmailsField value={form.watcher_emails} onChange={v => set('watcher_emails', v)} />
          </div>

          {/* Prioridad */}
          <div>
            <label style={{fontSize:10,fontWeight:700,letterSpacing:.8,textTransform:'uppercase',color:'#5B8DB8',display:'block',marginBottom:8}}>{t('ticket.priority')}</label>
            <div style={{display:'flex',gap:8}}>
              {PRIO.map(({ k, label, color }) => {
                const sel = form.priority === k;
                return (
                  <button key={k} onClick={() => set('priority', k)}
                    style={{flex:1,height:36,borderRadius:8,fontSize:12,fontWeight:700,cursor:'pointer',
                      background: sel ? color : '#F8FBFD',
                      color: sel ? '#fff' : '#9CA3AF',
                      border:'1.5px solid ' + (sel ? color : '#E0EEF7'),
                      boxShadow: sel ? '0 2px 6px ' + color + '40' : 'none',
                      transition:'all .15s'}}>
                    {label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Descripción */}
          <div>
            <label style={{fontSize:10,fontWeight:700,letterSpacing:.8,textTransform:'uppercase',color:'#5B8DB8',display:'block',marginBottom:6}}>{t('ticket.description')}</label>
            <textarea
              style={{...inputStyle, height:150, padding:'12px 14px', resize:'vertical', lineHeight:1.6, fontFamily:'inherit'}}
              placeholder="Detalles adicionales del problema…"
              value={form.description} onChange={e => set('description', e.target.value)}
              onFocus={e=>e.target.style.borderColor='var(--una-blue)'} onBlur={e=>e.target.style.borderColor='#C5D8E8'}
            />
          </div>

          {error && (
            <div style={{padding:'8px 12px',borderRadius:8,background:'#FEF2F2',color:'#B91C1C',fontSize:12,border:'1px solid #FCA5A5'}}>
              ⚠ {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{padding:'12px 24px 16px',display:'flex',justifyContent:'flex-end',gap:8,borderTop:'1px solid #F0F7FC'}}>
          <Button variant="secondary" onClick={onClose}>Cancelar</Button>
          <Button variant="primary" onClick={submit} disabled={saving || !valid}>
            <MIcon name="add" size={14}/>
            {saving ? 'Creando…' : 'Crear ticket'}
          </Button>
        </div>

      </div>
    </div>
  );
}
